import React, { useState } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';

// Specify worker source
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = ({ pdfFile,isLoad =false }) => {


  function LoadingScreen(){
    return(
      <>
      {
        isLoad === true ? (
<div className='w-full h-full flex items-center justify-center'>
                  <div className=" w-full h-[50vh] flex justify-center items-center">
                    <div className=" flex flex-col justify-center items-center">
                      <div className="flex flex-row gap-2">
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce" />
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.3s]" />
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.5s]" />
                        <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.7s]" />
                      </div>
                    </div>
                    
                  </div>
      </div>
        ): (isLoad == false && pdfFile) ?   
        <>
        <iframe
        src={pdfFile} // PDF URL or Blob URL
        style={{ width: '100%', height: '96%' }}
        frameBorder="0"
      />
        </>
        : <div className='w-full h-full flex items-center justify-center font-medium text-sm 2xl:text-base '>No PDF File Found</div>
      }
      </>
      
    )
  }

  return (
    <div className=' w-full h-full flex items-end'>
      <LoadingScreen/>
  </div>
  );
};

export default PDFViewer;
